import React from 'react';
import ReactDOM from 'react-dom/client';
import { CalculateMaximumMortgageCalculate, type CalculateMaximumMortgageCalculateProps } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/CalculateMaximumMortgageCalculate';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: CalculateMaximumMortgageCalculateProps;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <CalculateMaximumMortgageCalculate {...data} />
  </React.StrictMode>
);